import ModalViewModel from 'infra/ModalViewModel'
import { task } from 'mobx-task'
import { Router } from 'types/definitions'
import link from 'infra/link'
import Job from '../../../../Job'
import JobStore from '../../../../JobStore'
import { AlertFactory, AlertState } from '../../../../../alerts/Alert'

export class DeleteJobDialogViewModel extends ModalViewModel {
  constructor(
    public job: Job,
    private jobStore: JobStore,
    private router: Router,
    private alertFactory: AlertFactory,
  ) {
    super()
  }

  delete = task.resolved(async () => {
    const alert = this.alertFactory()
      .withState(AlertState.Pending)
      .saying('Deleting job', 'Hang tight!')
      .show()

    try {
      if (
        this.job.canDeleteJobAsCollaborator &&
        !this.job.canDeleteJobAsAdmin
      ) {
        await this.jobStore.deleteDraftAsCollaborator(this.job)
      } else {
        await this.jobStore.deleteJobAsAdmin(this.job)
      }

      this.close()
      this.router.push(link.jobs())

      alert
        .withState(AlertState.Success)
        .saying('Success!', 'Job has been deleted!')
    } catch (e) {
      console.error(e)

      alert
        .withState(AlertState.Error)
        .saying('Failed!', 'Could not delete this job.')
    }
  })
}
